import React from 'react';
import { Row } from '@intech/web-ui';
import { SmallColumn, CenteredColumn, LeftColumn } from './styles';

export const ResultadoHeader: React.FC = () => {

  return (
    <Row className={"mt-2"}>
      <SmallColumn>

      </SmallColumn>
      <LeftColumn>Nome</LeftColumn>
      <CenteredColumn>Matrícula</CenteredColumn>
      <CenteredColumn>CPF</CenteredColumn>
      <CenteredColumn>Empresa</CenteredColumn>
      <CenteredColumn>Plano</CenteredColumn>
      <CenteredColumn>

      </CenteredColumn>
    </Row>
  );
}